import { get, post } from "@/utils/request";
import type { Recall, CommonForm, Detail } from "@/types/procss";
import type { Response } from "@/types/axios";
//审批流程明细
export const GetWorkflowDetailList = (params: {
  WorkFlowId: number;
  IsLoadHistory: number;
}) => post("/api/Workflow/detail", params);

// 流程头部信息
export const getWorkflowData = (StaffId: number) =>
  post("/api/processNodes/getOpeningNodeInfo", {
    StaffId: StaffId,
    OpeningNodeInfoCode: "",
  });

//个人借款金额详情
export const borrowApplyDetail = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> => post("/api/borrow/applyDetail", params);
// 财务预算详情
export const financialApplyDetail = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> => post("/api/finance/budgetDetail", params);

// ===节点2开始===

// ---选址节点开始---

export const siteSelectionDetail = (params: { Id: number }) =>
  post("/api/siteSelection/siteSelectionDetail", params);

//提交房屋选址信息
export const submitSiteSelectionApply = (params: CommonForm) =>
  post("/api/siteSelection/submitSiteSelectionApply", params);

//更新选址申请
export const editSiteSelectionApply = (params: CommonForm) => {
  return post("/api/siteSelection/editSiteSelectionApply", params);
};
//撤回选址申请
export const recallSiteSelectionApply = (params: Recall) => {
  return post("/api/siteSelection/recallSiteSelectionApply", params);
};
//选址重新申请
export const siteSelectionReapply = (params: Recall) =>
  post("/api/siteSelection/reapply", params);
// ---选址节点结束---

// ---房屋选址节点开始---

//获取房屋租赁申请详情
export const houseRentDetail = (params: {
  Id: number | string;
  IsApproveDetail?: number;
}) => post("/api/houseRent/houseRentDetail", params);

//提交房屋租赁申请
export const submitHouseRentApply = (params: CommonForm) =>
  post("/api/houseRent/submitHouseRentApply", params);

//更新房屋租赁申请
export const editHouseRentApply = (params: CommonForm) =>
  post("/api/houseRent/editHouseRentApply", params);

//撤回房屋租赁申请
export const recallHouseRentApply = (params: Recall) =>
  post("/api/houseRent/recallHouseRentApply", params);

//回传房屋租赁
export const turnaroundHouseRentApply = (params: CommonForm) =>
  post("/api/houseRent/turnaroundHouseRentApply", params);

//撤回回传
export const recallTurnaroundHouseRentApply = (params: {
  Reason: string;
  BusinessFlowId: number | string;
}) => post("/api/houseRent/recallTurnaroundHouseRentApply", params);

// ---房屋选址节点结束---
// ---房屋选址节点开始---
//获取详情
export const decproDetail = (params: { Id: number | string }) =>
  post("/api/decpro/decproDetail", params);

//提交申请
export const submitdecproApply = (params: CommonForm) =>
  post("/api/decpro/submitDecproApply", params);

//更新申请
export const editDecproApply = (params: CommonForm) =>
  post("/api/decpro/editDecproApply", params);

//撤回申请
export const recallDecproApply = (params: Recall) =>
  post("/api/decpro/recallDecproApply", params);

//回传
export const turnaroundDecproApply = (params: {
  PageFiles: CommonForm;
  BranchCompanyFlowId: number | string;
}) => post("/api/decpro/turnaroundDecproApply", params);
export const recallTurnaroundDecproApply = (params: {
  PageFiles: CommonForm;
  BranchCompanyFlowId: number | string;
}) => post("/api/decpro/recallTurnaroundDecproApply", params);
// ---房屋选址节点结束---

// 节点2结束
// 提交正式开业
export const addCompanyGrand = (params: {
  Id: number;
  CompanyName: string;
  ContactPhone: string;
  TaxNo: string;
  BankAccount: string;
  Address: string;
  OpenAccountBank: string;
  GrandOpenTime: string;
}) => post("/api/companyGrand/add", params);
